export enum Language {
  Irish = 'Irish',
  English = 'English'
}